import moment from 'moment';
import { tipologieFase } from '../../constants/TipologiaFase';

export class FormUtility {

    regExprFiscalCode =
        "^([A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[ABCDEHLMPRSTabcdehlmprst][0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z])$";
	data = {};
	
	prefixes = ['+39', '+1', '+20', '+212', '+213', '+216', '+218', '+220', '+221', '+222', '+223', '+224', '+225', '+226', '+227', '+228', '+229', '+230', '+231', '+232', '+233', '+234', '+235', '+236', '+237', '+238', '+239', '+240', '+241', '+242', '+243', '+244', '+246', '+247', '+248', '+249', '+250', '+251', '+252', '+253', '+254', '+255', '+256', '+257', '+258', '+260', '+262', '+263', '+264', '+265', '+266', '+267', '+268', '+269', '+27', '+290', '+291', '+296', '+297', '+298', '+299', '+30', '+31', '+32', '+33', '+34', '+350', '+351', '+352', '+353', '+354', '+355', '+356', '+357', '+358', '+359', '+36', '+370', '+371', '+372', '+373', '+374', '+375', '+376', '+377', '+378', '+379', '+380', '+381', '+382', '+386', '+387', '+389', '+40', '+41', '+420', '+421', '+423', '+43', '+44', '+45', '+46', '+47', '+48', '+49', '+500', '+502', '+503', '+504', '+505', '+506', '+507', '+508', '+509', '+51', '+52', '+53', '+54', '+55', '+56', '+58', '+590', '+594', '+596', '+597', '+598', '+599', '+60', '+61', '+62', '+63', '+64', '+65', '+66', '+669', '+670', '+672', '+6721', '+6723', '+673', '+674', '+675', '+676', '+677', '+678', '+679', '+680', '+681', '+682', '+683', '+684', '+685', '+686', '+687', '+688', '+689', '+690', '+691', '+692', '+7', '+81', '+82', '+84', '+86', '+850', '+852', '+853', '+880', '+886', '+90', '+91', '+92', '+93', '+94', '+95', '+960', '+961', '+962', '+963', '+964', '+966', '+967', '+971', '+972', '+973', '+974', '+975', '+976', '+977', '+98', '+992', '+993', '+994', '+995', '+996', '+998', '+1264', '+1268', '+1284', '+1340', '+1345', '+1437', '+1441', '+1473', '+1490', '+1580', '+1649', '+1664', '+1721', '+1758', '+1767', '+1784', '+1787', '+1809', '+1829', '+1849', '+1868', '+1869', '+1876', '+1939'];

	colorClassBtnArsMap = {
		OK_PREV_CARR_INESISTENTE: 'rtds-btn--success', // VERDE
		OK_AMMESSO: 'rtds-btn--success', // VERDE
		OK_RESPINTO: 'rtds-btn--success', // VERDE
		NOT_FOUND: 'rtds-btn--dark rtds-border', // NERO
		NO_SCHOOL_UPLOAD: 'rtds-btn--neutral-700', // GRIGIO
		NO_SCHOOL_LIBRI: 'rtds-btn--brown', // MARRONE
		DATI_INVALIDI: 'rtds-btn--purple', // VIOLA
		NON_AMMISSIBILE_CONTRIBUTO_NON_PRESENTE: 'rtds-btn--danger', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_RITIRATO: 'rtds-btn--danger', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_RESPINTO: 'rtds-btn--danger', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_PRIMARIA: 'rtds-btn--danger', // ROSSO
		TRASFERITO_PRE_INIZIO_SCUOLA: 'rtds-btn--yellow', // GIALLO
		TRASFERITO_RITIRATO_NO_DATA_VARIAZIONE: 'rtds-btn--info', // BLU
		UCS_ERRATA_MINORE_CORRETTA: 'rtds-btn--lightgreen', // VERDE CHIARO
		UCS_ERRATA_MAGGIORE_CORRETTA: 'rtds-btn--orange' // ARANCIONE
	};

	colorClassAlertArsMap = {
		OK_PREV_CARR_INESISTENTE: 'rtds-bg-success-dark rtds-text-white', // VERDE
		OK_AMMESSO: 'rtds-bg-success-dark rtds-text-white', // VERDE
		OK_RESPINTO: 'rtds-bg-success-dark rtds-text-white', // VERDE
		NOT_FOUND: 'rtds-border rtds-bg-neutral-50', // NERO
		NO_SCHOOL_UPLOAD: 'rtds-bg-neutral-700 rtds-text-white', // GRIGIO
		NO_SCHOOL_LIBRI: 'rtds-bg--brown-30', // MARRONE
		DATI_INVALIDI: 'rtds-bg--purple-30', // VIOLA
		NON_AMMISSIBILE_CONTRIBUTO_NON_PRESENTE: 'rtds-bg-error-dark rtds-text-white', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_RITIRATO: 'rtds-bg-error-dark rtds-text-white', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_RESPINTO: 'rtds-bg-error-dark rtds-text-white', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_PRIMARIA: 'rtds-bg-error-dark rtds-text-white', // ROSSO
		TRASFERITO_PRE_INIZIO_SCUOLA: 'rtds-bg--yellow-30', // GIALLO
		TRASFERITO_RITIRATO_NO_DATA_VARIAZIONE: 'rtds-bg-info-dark rtds-text-white', // BLU
		UCS_ERRATA_MINORE_CORRETTA: 'rtds-bg--lightgreen-30', // VERDE CHIARO
		UCS_ERRATA_MAGGIORE_CORRETTA: 'rtds-bg--orange-30' // ARANCIONE
	};

	iconClassArsMap = {
		OK_PREV_CARR_INESISTENTE: 'solid--academic-cap', // VERDE
		OK_AMMESSO: 'solid--academic-cap', // VERDE
		OK_RESPINTO: 'solid--academic-cap', // VERDE
		NOT_FOUND: 'solid--academic-cap', // NERO
		NO_SCHOOL_UPLOAD: 'solid--academic-cap', // GRIGIO
		NO_SCHOOL_LIBRI: 'solid--academic-cap', // MARRONE
		DATI_INVALIDI: 'solid--academic-cap', // VIOLA
		NON_AMMISSIBILE_CONTRIBUTO_NON_PRESENTE: 'solid--x-mark', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_RITIRATO: 'solid--x-mark', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_RESPINTO: 'solid--x-mark', // ROSSO
		NON_AMMISSIBILE_CONTRIBUTO_PRIMARIA: 'solid--x-mark', // ROSSO
		TRASFERITO_PRE_INIZIO_SCUOLA: 'solid--academic-cap', // GIALLO
		TRASFERITO_RITIRATO_NO_DATA_VARIAZIONE: 'solid--academic-cap', // BLU
		UCS_ERRATA_MINORE_CORRETTA: 'solid--exclamation-circle', // VERDE CHIARO
		UCS_ERRATA_MAGGIORE_CORRETTA: 'solid--exclamation-circle' // ARANCIONE
	};

	colorClassBtnIstuttoriaArsMap = {
		POSITIVO: 'rtds-btn--success',
		NEGATIVO: 'rtds-btn--danger'
	};

	iconClassIstruttoriaArsMap = {
		POSITIVO: 'solid--check-circle',
		NEGATIVO: 'solid--x-mark',

	};

	constructor(data) {
		this.data = data;
	}

	/** Restituisce l'elenco dei prefissi
   * @returns l'elenco in formato vettore di stringhe di prefissi
	*/
	getPrefissi = () => {
		return this.prefixes;
	}

	checkLastCharCf = (cf) => {
		if(!cf) return false;
		const lastCharCf = cf[15];
		const cfParziale = cf.substring(0, 15);
		const setControllo = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		const setDispari = {
		  '0': 1,  '1': 0,  '2': 5,  '3': 7,  '4': 9,  '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
		  'A': 1,  'B': 0,  'C': 5,  'D': 7,  'E': 9,  'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
		  'K': 2,  'L': 4,  'M': 18, 'N': 20, 'O': 11, 'P': 3,  'Q': 6,  'R': 8,  'S': 12, 'T': 14,
		  'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23
		};
	
		const setPari = {
		  '0': 0,  '1': 1,  '2': 2,  '3': 3,  '4': 4,  '5': 5,  '6': 6,  '7': 7,  '8': 8,  '9': 9,
		  'A': 0,  'B': 1,  'C': 2,  'D': 3,  'E': 4,  'F': 5,  'G': 6,  'H': 7,  'I': 8,  'J': 9,
		  'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
		  'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25
		};
	
		let somma = 0;
	
		for(let i = 0; i <= cfParziale.length - 1; i++) {
		  const c = cfParziale[i];
		  somma += (i % 2 === 0) ? setDispari[c] : setPari[c];
		}
	
		const index = somma % 26;
		return lastCharCf !== setControllo[index];
	}

  checkFiscalCodeValidity = (validate, codiceFiscale, regExpr) => {
    if (!validate) {
      return '';
    }

    const value = codiceFiscale;
    if (!value) {
      return 'Campo obbligatorio';
    }

    if (value.length < 16) {
      return 'Deve avere lunghezza 16';
    }

    const re = new RegExp(regExpr);
    if (!re.test(value.toUpperCase())) {
      return 'Il campo non rispetta lo schema riconosciuto';
    }

		if(value.length === 16 && this.checkLastCharCf(value.toUpperCase())) {
			return 'Codice fiscale non valido';
		}

    return '';
  };

	/**Controlla che il ruolo selezionato sia tra quelli elencati
   * @param {any} ruoli elenco ruoli accettati
   * @returns true se il ruolo selezionato è presente, false altrimenti
	*/
	checkRoles = (ruoli) => {
    if (!ruoli || !this.data?.data?.authorities) return false;

		let find = false;
		ruoli.every(role => {
			find = !!this.data?.data.authorities.find(ruolo => ruolo === role) && this.data?.data.selected === role;
			return !find;
		});
		return find;
  }

	/**
	 * Restituisce tutti i campi in errore della form
	 * @param {*} formRef il riferimento alla form
	 */
	getAllInputErrors = (formRef) => {
		return [...formRef.current.elements].filter(field => !field.disabled && !field.readOnly && !field.validity.valid);
	}

	/**
	 * Restituisce tutti i campi in errore della form ed eventualmente setta il focus
	 * @param {*} formRef il riferimento alla form
	 * @param {*} setFocus setta il focus sul primo campo in errore
	 * @param {*} fieldToCheck l'eventuale campo aggiuntivo alla form che non è verificabile dalla validity standard
	 */
	checkFormErrorsAndFocus = (formRef, setFocus = false, fieldToCheck = null) => {
		const errors = [...formRef.current.elements].filter(field => !field.disabled && !field.readOnly && !field.validity.valid);

		if (setFocus) {
      if (errors.length > 0) {
        errors[0].focus();
      } else {
        formRef.current.elements[fieldToCheck].focus();
      }
    }

		return errors;
	}

	/**Controlla se la fase richiesta è attiva
   * @param {number | string} fase		 	 	 l'id della fase richiesta
   * @param {string} 					startField 	 il campo di inizio data (di default è dataInizio)
   * @param {string} 					endField 	 	 il campo di fine data (di default è dataFine)
   * @param {string} 					formatStart  il formato della data di inizio (di default è YYYY-MM-DD HH:mm:ss)
   * @param {string} 					formatEnd		 il formato della data di fine (di default è YYYY-MM-DD HH:mm:ss)
   * @returns true se la fase è attiva, false altrimenti
	*/
	checkFaseIsActive = (fase, startField = 'dataInizio', endField = 'dataFine', formatStart = 'YYYY-MM-DD HH:mm:ss', formatEnd = 'YYYY-MM-DD HH:mm:ss') => {
		if (!fase) {
			return false;
		}

		const date = moment();
		const dateStart = date.format(formatStart);
		const dateEnd = date.format(formatEnd);
		return (!startField || moment(fase[startField]).isSameOrBefore(dateStart)) && (!endField || moment(fase[endField]).isSameOrAfter(dateEnd));
	}

	getAllTipologie = () => {
		return [
			{
				key: tipologieFase.presentazione_domande,
				value: 'Presentazione domande',
			},
			{
				key: tipologieFase.istruttoria,
				value: 'Istruttoria'
			},
			{
				key: tipologieFase.secondo_accesso_non_ammessi_sospesi,
				value: 'Secondo accesso',
			},
			{
				key: tipologieFase.terzo_accesso_sospesi,
				value: 'Terzo accesso sospesi',
			},
			{
				key: tipologieFase.aggiornamento_isee,
				value: 'Rettifica domande presentate',
			},
			{
				key: tipologieFase.rettifica_iban,
				value: 'Rettifica IBAN',
			},
			{
				key: tipologieFase.riapertura_presentazione,
				value: 'Riapertura presentazione',
			},
			{
				key: tipologieFase.annullamento_domande,
				value: 'Annullamento domande',
			}
		];
	}

	/**
	 * Ottiene l'anno precedente a quello passato come parametro
	 * @param {*} annoEducativo l'anno educativo in formato 'YYYY/YY'
	 * @returns l'anno precedente in formato 'YYYY/YY'
	 */
	ottieniAnnoPrecedente = (annoEducativo) => {
        if (!annoEducativo)return '';
		const [anno, annoCorso] = annoEducativo?.split('/');
		const annoPrecedente = parseInt(anno, 10) - 1;
		const annoCorsoPrecedente = parseInt(annoCorso, 10) - 1;
		return `${annoPrecedente}/${annoCorsoPrecedente.toString().padStart(2, '0')}`;
	}

    ottieniPrimaParteAnnoEducativo = (annoEducativo) => {
		const [anno, annoCorso] = annoEducativo?.split('/');
		return anno;
	}

	/**
	 * Genera nel dom l'area per scaricare un file
	 * @param {*} data     il file scaricato
	 * @param {*} filename il nome del file
	 * @param {*} type     il tipo del file generato (se non specificato è un file pdf)
	 */
	downloadFile = (data, filename) => {
		const blob = data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
	}

	/**
	 * Restituisce il numero inserendo i punti delle migliaia ovunque servano
	 * @param {number | string} value il numero su cui inserire le migliaia
	 * @returns il valore modificato se il valore è veriso da null, una stringa vuota altrimenti
	 */
	insertDotForThousands(value) {
    return value !== '' && value !== null && value !== undefined
              ? value.toString().replace(/\B(?!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
              : '';
  }

	/**
	 * Esegue un click sulla pagina attuale. Utile ad esempio per chiudere popover o rimuovere il focus attuale.
	 */
	clickOnDocument = () => {
		document.body.click();
	}

	/**
	 * Ottiene il numero del mese a partire dal carattere del codice fiscale
	 * @param {*} mese il carattere che indentifica il mese
	 * @returns il numero del mese se esiste, null altrimenti
	 */
	ottieniMeseDaCodiceFiscale(mese) {
		switch (mese) {
			case 'A':
				return 1;
			case 'B':
				return 2;
			case 'C':
				return 3;
			case 'D':
				return 4;
			case 'E':
				return 5;
			case 'H':
				return 6;
			case 'L':
				return 7;
			case 'M':
				return 8;
			case 'P':
				return 9;
			case 'R':
				return 10;
			case 'S':
				return 11;
			case 'T':
				return 12;
			default:
				return;
		}
	}

	/**
	 * Calcola l'età del soggetto dal codice fiscale
	 * @param {*} codiceFiscale il codice fiscale
	 * @returns il valore dell'età
	 */
	ottieniEtaDaCodiceFiscale(codiceFiscale) {
    const anno = parseInt(codiceFiscale.substring(6, 8), 10);
		const month = codiceFiscale[8];
    const mese = this.ottieniMeseDaCodiceFiscale(month);
		const day = parseInt(codiceFiscale.substring(9, 11));
		const giorno = day > 31 ? day - 40 : day;

    const annoCorr = anno < 22 ? 2000 + anno : 1900 + anno;

    const dataNascita = new Date(annoCorr, mese - 1, giorno);

    const oggi = new Date();

    let eta = oggi.getFullYear() - dataNascita.getFullYear();
  
    const compleannoPassato = oggi.getMonth() > dataNascita.getMonth() ||
      (oggi.getMonth() === dataNascita.getMonth() && oggi.getDate() >= dataNascita.getDate());

    if (!compleannoPassato) {
      eta--;
    }
  
    return eta;
  }

	/**
	 * Calcola la data di nascita del soggetto dal codice fiscale
	 * @param {*} codiceFiscale il codice fiscale
	 * @returns il valore della data di nascita
	 */
	ottieniDataNascitaDaCodiceFiscale(codiceFiscale) {
		const anno = parseInt(codiceFiscale.substring(6, 8), 10);
		const month = codiceFiscale[8];
    const mese = this.ottieniMeseDaCodiceFiscale(month);
		const day = parseInt(codiceFiscale.substring(9, 11));
		const giorno = day > 31 ? day - 40 : day;

		const annoCorr = anno < 22 ? 2000 + anno : 1900 + anno;

		const dataNascita = new Date(annoCorr, mese - 1, giorno);

		return dataNascita;
	}

	/**
	 * Calcola l'età solare del soggetto dal codice fiscale
	 * @param {*} codiceFiscale il codice fiscale
	 * @returns il valore dell'età solare
	 */
	ottieniEtaMillesimoDaCodiceFiscale(codiceFiscale) {
    const anno = parseInt(codiceFiscale.substring(6, 8), 10);
    const annoCorr = anno < 22 ? 2000 + anno : 1900 + anno;

    const dataNascita = new Date(annoCorr, 0, 1);

    const oggi = new Date();

    let eta = oggi.getFullYear() - dataNascita.getFullYear();
  
    const compleannoPassato = oggi.getMonth() > dataNascita.getMonth() ||
      (oggi.getMonth() === dataNascita.getMonth() && oggi.getDate() >= dataNascita.getDate());

    if (!compleannoPassato) {
      eta--;
    }
  
    return eta;
  }

	/**
	 * Calcola l'età del soggetto dal codice fiscale in fase di rettifica
	 * @param {*} codiceFiscale 		il codice fiscale
	 * @param {*} dataPresentazione la data di presentazione
	 * @returns il valore dell'età
	 */
	ottieniEtaDaCodiceFiscaleRettifica(codiceFiscale, dataPresentazione) {
    const anno = parseInt(codiceFiscale.substring(6, 8), 10);
		const month = codiceFiscale[8];
    const mese = this.ottieniMeseDaCodiceFiscale(month);
		const day = parseInt(codiceFiscale.substring(9, 11));
		const giorno = day > 31 ? day - 40 : day;

    const annoCorr = anno < 22 ? 2000 + anno : 1900 + anno;

    const dataNascita = new Date(annoCorr, mese - 1, giorno);

    let eta = dataPresentazione.getFullYear() - dataNascita.getFullYear();
  
    const compleannoPassato = dataPresentazione.getMonth() > dataNascita.getMonth() ||
      (dataPresentazione.getMonth() === dataNascita.getMonth() && dataPresentazione.getDate() >= dataNascita.getDate());

    if (!compleannoPassato) {
      eta--;
    }
  
    return eta;
  }

	/**
	 * Calcola l'età solare del soggetto dal codice fiscale in fase di rettifica
	 * @param {*} codiceFiscale 		il codice fiscale
	 * @param {*} dataPresentazione la data di presentazione
	 * @returns il valore dell'età solare
	 */
	ottieniEtaMillesimoDaCodiceFiscaleRettifica(codiceFiscale, dataPresentazione) {
    const anno = parseInt(codiceFiscale.substring(6, 8), 10);
    const annoCorr = anno < 22 ? 2000 + anno : 1900 + anno;

    const dataNascita = new Date(annoCorr, 0, 1);

    let eta = dataPresentazione.getFullYear() - dataNascita.getFullYear();
  
    const compleannoPassato = dataPresentazione.getMonth() > dataNascita.getMonth() ||
      (dataPresentazione.getMonth() === dataNascita.getMonth() && dataPresentazione.getDate() >= dataNascita.getDate());

    if (!compleannoPassato) {
      eta--;
    }
  
    return eta;
  }

	/**
	 * Restituisce l'errore migliore in base al responso del server
	 * @param {*} error 		l'errore del server
	 * @param {*} baseError il messaggio di errore base
	 * @returns Restituisce la stringa migliore possibile rappresentante l'errore del server, l'errore di base baseError (se passato), un genereico 'Errore' altrimenti
	 */
	getErrorMsg = (error, baseError = null) => {
		const errMsg = error?.response?.data;

		if (Array.isArray(errMsg)) {
			return baseError;
		}

		if (!Array.isArray(errMsg) && errMsg?.startsWith('un valore chiave duplicato')) {
			return 'Attenzione! Valore duplicato. L\'operazione non è stata possibile';
		}

		return errMsg ?? baseError ?? 'Errore';
	}

	/**
 	 * Restituisce i filtri contenuti nel session storage
	 * @params {*} location					l'oggetto location per il pathname
	 * @params {*} path							il suffisso del percorso della chiave dello storage
	 * @params {*} specificPathname se lo storage fa riferimento a una chiave non dipendente dalla location (opzionale)
	 * @returns Restituisce la lista dei filtri parsati se presenti nello storage, null altrimenti
 	*/
	getFiltriAvanzatiStorage = (location, path, specificPathname = null) => {
		const optionsJson = sessionStorage.getItem(
			`${specificPathname ?? location.pathname}${path}`
		);
		return optionsJson ? JSON.parse(optionsJson) : null;
	};

	/**
	 * Ottiene il valore di un campo da un oggetto
	 * @param {*} obj 	l'oggetto
	 * @param {*} field il campo
	 * @returns il valore del campo se esiste, null altrimenti
	 */
	getValueFromObj = (obj, field) => {
		return obj?.[field];
	}

	/**
	 * Rimuove gli elementi dallo storage sessione in base ai suffissi forniti
	 * @param {*} suffixes 
	 */
	clearSessionStorageBySuffixes = (suffixes = []) => {
		const keysToRemove = [];

		for (let i = 0; i < sessionStorage.length; i++) {
			const key = sessionStorage.key(i);
			if (suffixes.some(suffix => key.endsWith(suffix))) {
				keysToRemove.push(key);
			}
		}

		keysToRemove.forEach(key => sessionStorage.removeItem(key));
	}

	/**
	 * Restituisce il nome ripestto al codice dell'ordine. Se non esiste, restituisce -
	 * @param {*} codiceOrdine il codice dell'ordine
	 * @param {*} fromLibri flag per stabilire se il valore del codice viene da una tabella di libri (default true)
	 * @returns La stringa relativa al codice
	 */
	getOrdineName = (codiceOrdine, fromLibri = true) => {
		if (fromLibri) {
			switch (codiceOrdine) {
				case 'MEDIA':
					return 'Secondaria I° Grado';
				case 'SUPERIORE':
					return 'Secondaria II° Grado';
				default:
					return '-';
			}
		}

		switch (codiceOrdine) {
			case 'E':
				return 'Primaria';
			case 'I':
				return 'Secondaria I° Grado';
			case 'S':
				return 'Secondaria II° Grado';
			default:
				return '-';
		}
	}

    bandoInstructions = [
		{ key: '3I', value: 'Regole relative all\'avviso del 2025/26' },
        { key: '4I', value: 'Regole relative all\'avviso del 2026/27' }
	];

    getINPS_ISEE_CurrentYear = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        return `INPS-ISEE-${currentYear}-`;
    };

}
